import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useEffect } from "react";
import config from "../../../config"; // Hooks

import useApi from "../../../api"; // Components

import SocialSharing from "../../../components/SocialSharing";
import Package from "../../../components/Package";
import BackButton from "../../../components/BackButton";
import { withUserMenu } from "../../../components/UserMenu";
import StreetView from "./components/StreetView";
import "./details.scss";

var TownhomeDetailsPageComponent = function TownhomeDetailsPageComponent(a) {
  var b = a.userMenu,
      c = a.match,
      d = useApi(),
      e = (c.params.slug || "").toLowerCase(),
      f = d.townhomes.list(),
      g = d.townhomes.retrieve(e),
      h = g ? g.lots.filter(function (a) {
    return 1 === a.status;
  }) : [],
      i = g && g.lots && h.length ? h[0] : null,
      j = useState(i),
      k = _slicedToArray(j, 2),
      l = k[0],
      m = k[1],
      n = useState(),
      o = _slicedToArray(n, 2),
      p = o[0],
      q = o[1],
      r = _slicedToArray(b, 2),
      s = r[1];

  useEffect(function () {
    var a = l.packages || [],
        b = _slicedToArray(a, 1),
        c = b[0];

    c && s.addRecentlyViewed(c);
  }, [s, l]); // @TODO add 404 page

  if (!g) return "Townhome not found"; // @TODO UPDATE WHEN THE API IS READY
  // TOWNHOME LOT SHOUDN'T HAVE AN ARRAY OF PACKAGES

  var t = l ? l || {
    packages: []
  } : {
    packages: []
  },
      u = _slicedToArray(t.packages, 1),
      v = u[0],
      w = void 0 === v ? {} : v,
      x = w.floorplan_ground_image && !w.floorplan_first_image || !w.floorplan_ground_image && w.floorplan_first_image,
      y = x ? {
    width: "100%"
  } : {},
      z = 1 < f.length; // console.log('activeLot', activeLot);


  return /*#__PURE__*/React.createElement("section", {
    className: "ta-townhomes ta-container"
  }, z ? /*#__PURE__*/React.createElement(BackButton, {
    title: "all townhomes",
    to: config.routes.get("townhomes"),
    external: !0
  }) : null, /*#__PURE__*/React.createElement("div", {
    className: "ta-row"
  }, /*#__PURE__*/React.createElement(StreetView, {
    image: g.image_streetscape,
    lots: g.lots,
    onHover: function onHover(a) {
      p !== a && q(a);
    },
    onClick: function toggleActiveLot(a) {
      var b = g.lots.find(function (b) {
        return b.slug === a;
      });
      b && m(b);
    },
    hovered: p,
    active: l.slug
  }), l && w ? /*#__PURE__*/React.createElement("div", {
    className: "ta-townhomes--info"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ta-townhomes--info__mobile"
  }, w && w.inclusions && /*#__PURE__*/React.createElement("div", {
    className: "package--inclusions"
  }, /*#__PURE__*/React.createElement("h5", null, "Inclusions"), /*#__PURE__*/React.createElement("p", {
    dangerouslySetInnerHTML: {
      __html: w.inclusions
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "package--inclusions"
  }, /*#__PURE__*/React.createElement("h5", null, "Share"), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement(SocialSharing, null)))), /*#__PURE__*/React.createElement("div", {
    className: "ta-townhomes--floorplans"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ta-townhomes--floorplans__wrapper"
  }, w.floorplan_ground_image ? /*#__PURE__*/React.createElement("div", {
    className: "ta-townhomes--floorplans__item",
    style: y
  }, /*#__PURE__*/React.createElement("img", {
    src: w.floorplan_ground_image,
    alt: w.name
  }), x ? "Floor plan" : "Ground floor") : null, w.floorplan_first_image ? /*#__PURE__*/React.createElement("div", {
    className: "ta-townhomes--floorplans__item",
    style: y
  }, /*#__PURE__*/React.createElement("img", {
    src: w.floorplan_first_image,
    alt: w.name
  }), x ? "Floor plan" : "First floor") : null)), /*#__PURE__*/React.createElement(Package, {
    package: w,
    showScrollToMap: !0,
    isDetail: !0,
    showShare: !0
  })) : null));
};

export var TownhomeDetailsPage = withUserMenu(TownhomeDetailsPageComponent);
export default TownhomeDetailsPage;